import { useMemo } from 'react';
import hand from '~/assets/icons/hand.svg';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { TechTuningCategory, TechTuningRarity } from '~/shared';
import {
	setCaseResultVisible,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { CategoryItemImages, CategoryNames } from '../CategoryTab';
import { TuningShopRarityColors } from '../ItemColor';
import {
	StyledButtonContainer,
	StyledButtonContent,
	StyledButtonLight,
	StyledCategory,
	StyledContainer,
	StyledImage,
	StyledName,
	StyledShadow,
	StyledWrapper,
} from './CaseResult.styled';

const CaseResult = () => {
	const dispatch = useLayoutDispatch();
	const allItems = useObservable(rage.techTuning.getItems());
	const caseResult = useLayoutSelector(
		(state) => state.tuningShop.caseResultItem,
	);

	const item = useMemo(
		() => allItems.find((item) => item.id === caseResult),
		[allItems, caseResult],
	);

	return (
		<StyledWrapper>
			<StyledShadow
				style={{
					backgroundColor:
						TuningShopRarityColors[item?.rarity || TechTuningRarity.COMMON],
				}}
			/>
			<StyledContainer>
				<StyledCategory>
					<Text>
						{CategoryNames[item?.category || TechTuningCategory.ENGINE]}
					</Text>
				</StyledCategory>
				<StyledName>{item?.name}</StyledName>
				<StyledImage
					src={CategoryItemImages[item?.category || TechTuningCategory.ENGINE]}
				/>
				<StyledButtonContainer>
					<StyledButtonLight />
					<Button
						color={ButtonColors.Select}
						height={ButtonHeight.Height50}
						onClick={() => dispatch(setCaseResultVisible(false))}
					>
						<StyledButtonContent>
							<img width={20} height={20} src={hand} />
							<Text>Забрать награду</Text>
						</StyledButtonContent>
					</Button>
				</StyledButtonContainer>
			</StyledContainer>
		</StyledWrapper>
	);
};

export { CaseResult };
